<template>
  <div class="field-input-radio">
    <div class="input-group">
      <div class="btn-group btn-group-toggle" data-toggle="buttons">
        <label v-for="(item, i) in fieldData.values" :key="i"
          :class="optionClasses(item, i)">
          <input
          type="radio"
          v-model="fieldData.field_value"
          :value="item.internal_value"
          :name="fieldData.field_name"
          :id="fieldData.field_name + '_radio_option_' + i"
          autocomplete="off">
          <span v-html="item.display_value"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'widgetStyle'],
  methods: {
    optionClasses(item, i) {
      const optionClasses = {};

      optionClasses.btn = true;
      optionClasses[this.widgetStyle] = !!(this.widgetStyle);
      optionClasses[`radio_option radio_option_${i}`] = true;
      optionClasses[item.product_class] = true;
      optionClasses.active = (this.fieldData.field_value === item.internal_value);

      return optionClasses;
    },
  },
};
</script>

<style lang="scss" scoped>
/*
  TODO: Add IE/Edge support by implementing the `label.btn` styles via JavaScript. Bootstrap adds classes
  'focus' and 'active' to the radio <input>'s "closest" element, which happens to be the <label>.
  See https://github.com/twbs/bootstrap/blob/7c7a1706c348fcb5290a63d9249e0c8e4b6ebbcf/js/src/button.js#L153 .
*/
label.btn:focus-within {
  color: #fff;
  background-color: #001a33;
  border-color: #001326;
  z-index: 1;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
}
.renter_filter_css {
  border-color: $var-color-renter !important;
  color: $var-color-renter !important;
}
.renter_filter_css:hover {
  background-color: $var-color-renter !important;
  color: #ffffff !important;
}
.home_filter_css {
  border-color: $var-color-home !important;
  color: $var-color-home !important;
}
.home_filter_css:hover {
  background-color:$var-color-home !important;
  color: #ffffff !important;
}
.condo_filter_css {
  border-color: $var-color-condo !important;
  color: $var-color-condo !important;
}
.condo_filter_css:hover {
  background-color: $var-color-condo !important;
  color: #ffffff !important;
}
.auto_filter_css {
  border-color: $var-color-auto !important;
  color: $var-color-auto !important;
}
.auto_filter_css:hover{
  background-color:$var-color-auto;
  color: #ffffff !important;
}

// Needed to override defaults
.btn-group .btn:last-of-type {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
.btn-group .btn:first-child {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

label.btn {
  display:inline-block;
  font-size:0.75rem;
  margin-right: 2.25rem;
  padding: 0.3em 0.3em;
  align-items: center;
  justify-content: space-evenly;
  text-transform: none;
  margin: 0rem;
  border: solid 0.1em;
  padding: 0.1em 1.75em;

  // Not "colorful" style
  &.radio_option {
      color: #3674B2;

      &.active {
        background-color: #3674B2;
        border-color: #3674B2;
        color: #fff;
      }
  }

  // "colorful" style
  &.colorful.radio_option {
    &.radio_option_0 {
      color: $var-color-auto;

      &.active {
        background-color: $var-color-auto;
        border-color: $var-color-auto;
        color: #fff !important;
      }
    }

    &.radio_option_1 {
      color: $var-color-home;

      &.active {
        border-color: $var-color-home !important;
        background-color:$var-color-home !important;
        color: #fff !important;
      }
    }

    &.radio_option_2 {
      color: $var-color-condo;

      &.active {
        background-color: $var-color-condo;
        border-color: $var-color-condo;
        color: #fff !important;
      }
    }

    &.radio_option_3 {
      color: $var-color-renter;

      &.active {
        background-color: $var-color-renter;
        border-color: $var-color-renter;
        color: #fff !important;
      }
    }

    input:disabled {
      color: #BBB;
    }
  }
}
.input-group {
  display:inline-flex;
}
</style>

<style>
i.qrp-icon-font {
  font-family: 'Font Awesome 5 Pro', 'Font Awesome 5 Free';
  font-weight: 600;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputRadioalt.vue?7a24973c